import type { IconSvgObject } from './types';

const FoldersIcon: IconSvgObject = [
  ["path", { d: "M21 6.5H14.9271C14.2795 6.5 13.6719 6.18638 13.2968 5.65841L11.6506 3.34159C11.2755 2.81362 10.6679 2.5 10.0202 2.5L3 2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.68421 9H12M12 9H19C20.1046 9 21 9.89543 21 11V19.5C21 20.6046 20.1046 21.5 19 21.5H5C3.89543 21.5 3 20.6046 3 19.5V6.5C3 5.94772 3.44772 5.5 4 5.5H9.10083C9.43274 5.5 9.74302 5.66468 9.92903 5.93957L12 9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FoldersIcon;
